import React, { useState } from 'react';
import { Link , useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';



const Login = () => {
    const{signInUsingGoogle, handleUserLoginWithEmail}= useAuth();



    const [email, setEmail]=useState('');
    const [password, setPassword]= useState('');
    const history= useHistory();
    const location = useLocation();
    const redirectsUrl= location.state?.from || "/home";

    const handleEmail=(e)=>{
        setEmail(e.target.value);
    }
    const handlePassword=(e)=>{
        setPassword(e.target.value);
    }
    const handleLoginWithEmail=(e)=>{
        e.preventDefault();
        handleUserLoginWithEmail(email, password)
        history.push(redirectsUrl);
        
    }
    return (
        <div className="mt-5 pt-5 pb-5 mb-5">
          
           <h2>please Login</h2>
           <form>
               <input onChange={handleEmail} type="email" placeholder="Enter your Email" id="" className="mb-3"/><br />
               <input onChange={handlePassword}  type="password" placeholder="Password" id="" /><br />
               <input onClick={handleLoginWithEmail} type="submit" className="btn btn-danger mt-3" value="Submit" />
           </form>
           <p>or</p>
            <button className="btn btn-danger" onClick={signInUsingGoogle}>Google Sign In</button>
            
            <Link to="/register">New User?</Link>
           
        </div>
    );
};

export default Login;